import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setIsOpen(false);
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        className="text-lg hover:text-red-500 transition duration-300 bg-transparent text-white border border-white hover:border-red-500 rounded-md p-2 focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        {i18n.language === 'en' ? 'English' : 'Italiano'}
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 lg:left-0 mt-1 bg-white text-black rounded-md shadow-lg z-50">
          <button
            onClick={() => handleChangeLanguage('en')}
            className="block px-4 py-2 text-sm hover:bg-gray-200 w-full text-left hover:rounded-md"
          >
            English
          </button>
          <button
            onClick={() => handleChangeLanguage('it')}
            className="block px-4 py-2 text-sm hover:bg-gray-200 w-full text-left hover:rounded-md"
          >
            Italiano
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
